import React, { useEffect } from "react";
import "./About.css";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion";

function About() {
  const { ref, inView } = useInView();
  const animation = useAnimation()
  const animationHead = useAnimation()

  useEffect(() => {
     if(inView){
      animationHead.start({
        opacity: 1,
        transition: { delay: 0.3, ease: "easeInOut" },
       })
       animation.start({
         opacity: 1,
         transition: { delay: 0.8, ease: 'easeInOut' }
       })
     }else if(!inView){
      animationHead.start({
        opacity: 0
     })
       animation.start({
         opacity: 0
       })
     }
  },[animation, animationHead, inView])

  return (
    <div ref={ref} className="about">
      <div id="about" className="wrapper">
        <div className="about__header">
          <motion.hr animate={animationHead} className="hr__line1" />
          <motion.h2 animate={animationHead}>About Me</motion.h2>
          <motion.hr animate={animationHead} className="hr__line2" />
        </div>
        <motion.div
          // initial={{ x: -1000 }}
          animate={animation}
          // transition={{ type: "spring", duration: 2, bounce: 0.5 }}
          className="about__content"
        >
          <div className="content__summary">
            <h3 className="spinX">~ My Journey ~</h3>
            <p>
              Hello, I am Gamseng M Marak, an Engineering graduate from 
               India. I am born and raised in Tura, Meghalaya which is located at the North-Eastern part of India. I love
              coding and I have been working as a software developer for
              around 3+ years now. 
            </p>
            <p>
              Technology is booming all over the world and I am glad that I could contribute
              something to the tech world. In no time, Newer technologies were also
              introduced. And nothing excites me more than getting my hands on
              those Technologies.
            </p>
          </div>
          <div className="profile__pic">
            <div className="image__wrapper">
              <img
                className="myProfile__image"
                src={require("../image/myPic.png")}
                alt=""
              />
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default About;
